import { useDOMRef, useStyleProps } from '@react-spectrum/utils'
import { DOMRef } from '@react-types/shared'
import React, { forwardRef } from 'react'
import { TrayProps } from '@react-types/overlays'
import { useOverlay } from '@react-aria/overlays'
import { Overlay } from '../Overlay'
import { Underlay } from '../Underlay'
import { TrayWrapper } from './TrayWrapper'

interface ExtendedTrayProps extends TrayProps {
  label?: string
  isSearchable?: boolean
  trayContainerClassName?: string
  trayChildrenWrapperClassName?: string
}

function Tray(props: ExtendedTrayProps, ref: DOMRef<HTMLDivElement>) {
  const {
    children,
    onClose,
    isFixedHeight,
    isNonModal,
    label,
    isSearchable,
    trayChildrenWrapperClassName,
    trayContainerClassName,
    ...otherProps
  } = props
  const domRef = useDOMRef(ref)
  const { styleProps } = useStyleProps(props)

  const { overlayProps, underlayProps } = useOverlay(
    { ...props, isDismissable: true },
    domRef
  )

  return (
    //@ts-ignore
    <Overlay {...otherProps}>
      <Underlay {...underlayProps} />
      <TrayWrapper
        {...styleProps}
        onClose={onClose}
        isSearchable={isSearchable}
        ref={domRef}
        overlayProps={overlayProps}
        isFixedHeight={isFixedHeight}
        isNonModal={isNonModal}
        label={label}
        trayChildrenWrapperClassName={trayChildrenWrapperClassName}
        trayContainerClassName={trayContainerClassName}
      >
        {children}
      </TrayWrapper>
    </Overlay>
  )
}

const _Tray = forwardRef(Tray)
export { _Tray as Tray }
